import PropTypes from 'prop-types';
import React from 'react';
import ReportCarousel from '../ReportCarousel/ReportCarousel';
import ReportGraph from '../ReportGraph/ReportGraph';
import ReportMap from '../ReportMap/ReportMap';
import ReportTable from '../ReportTable/ReportTable';

const ReportControl = ({ loot, value }) => {
  function tableFormart(ID, Name, Expertise, Score, aiTop, Image) {
    return {
      ID,
      Name,
      Expertise,
      Score,
      aiTop,
      Image
    };
  }
  const generateTable = (target) => {
    const lister = [];
    if (target.topHospList) {
      let len1 =
        target.topHospList.length > 10 ? 10 : target.topHospList.length;
      for (let i = 0; i < len1; i++) {
        const IDholder = i + 1;
        const Nameholder = target.topHospList[i].name;
        const Expertiseholder = target.topHospList[i].overallSCoreDisplay;
        const SCoreholder = target.topHospList[i].overallSCoreDisplay;
        const aiTop = target.topHospList[i].aiTop
          ? target.topHospList[i].aiTop
          : i <= 3
          ? 1
          : 0;
        const Image = target.topHospList[i].logUrl;

        lister.push(
          tableFormart(
            IDholder,
            Nameholder,
            Expertiseholder,
            SCoreholder,
            aiTop,
            Image
          )
        );
      }
    }
    return lister;
  };

  const generateMap = (target) => {
    const templist = [['City', 'Score', { role: 'tooltip', type: 'string' }]];
    if (target.topHospList) {
      let len1 =
        target.topHospList.length > 10 ? 10 : target.topHospList.length;
      for (let v = 0; v < len1; v++) {
        templist.push([
          target.topHospList[v].city + ' ' + target.topHospList[v].state,
          target.topHospList[v].overallSCoreDisplay,
          target.topHospList[v].name.concat(
            ': ',
            target.topHospList[v].overallSCoreDisplay
          )
        ]);
      }
    }
    return templist;
  };

  const generateALL = (target) => {
    const templist = [['City', 'Score', { role: 'tooltip', type: 'string' }]];
    if (target.topHospList) {
      target.topHospList.forEach((hospital) => {
        templist.push([
          hospital.city + ' ' + hospital.state,
          hospital.overallSCoreDisplay,
          hospital.name.concat(': ', hospital.overallSCoreDisplay)
        ]);
      });
    }
    return templist;
  };

  console.log('Loot in report  control', loot);
  switch (value) {
    case 0:
      return <ReportCarousel tableData={generateTable(loot)} />;
    case 1:
      return <ReportTable tableData={generateTable(loot)} />;
    case 2:
      return (
        <ReportMap
          displayData={generateMap(loot)}
          allData={generateALL(loot)}
        />
      );
    case 4:
      return <ReportGraph />;

    default:
      return <ReportCarousel tableData={generateTable(loot)} />;
  }
};

ReportControl.propTypes = {
  loot: PropTypes.array.isRequired,
  value: PropTypes.number.isRequired
};
export default ReportControl;



// WEBPACK FOOTER //
// ./src/components/ReportControl/ReportControl.js